import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { VLink } from '../../other/vLink';

const Button = ({ label, link }: { label: string; link: string }) => {
  const className = `text-black uppercase inline-block py-3 px-5 md:px-8 mr-4 bg-transparent text-md md:text-xl border border-stone mb-5`;
  return <VLink className={className} to={link}>{label}</VLink>;
};

const HeroContainer = styled.div<{ backgroundImage: string }>(({ backgroundImage }) => `
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-blend-mode: multiply;
  min-height: 600px;
  padding: 35% 32px 0px 32px;

  @media (min-width: 1080px) {
    padding: 0 64px;
  }

  @media (min-width: 768px) {
    height: 90vh;
  }
`);

const Animated = styled.h1`
  animation: i .8s .4s cubic-bezier(.41,.01,.27,1) both;
  @keyframes i {
    0% {
        opacity: 0;
        -webkit-transform: translateY(3.125rem);
        transform: translateY(3.125rem)
    }

    to {
        opacity: 1;
        -webkit-transform: none;
        transform: none
    }
}
`;

const Grow = styled.div`
  animation: line-grow 0.8s forwards;
  animation-delay: 0.8s;
  @keyframes line-grow {
    from { width: 0px; }
    to { width: 48px; }
  }
`;

interface HeroProps {
  headline: string;
  subtitle: string;
  button1Label: string;
  button1Link: string;
  button2Label: string;
  button2Link: string;
  imageRow1: Asset[];
  imageRow2: Asset[];
  backgroundImage?: Asset;
}

export const Hero: React.FC<HeroProps> = ({
  headline,
  subtitle,
  button1Label,
  button1Link,
  button2Label,
  button2Link,
  backgroundImage,
}) => {
  return (
    <HeroContainer
      className="relative flex flex-col justify-end text-black border-b sm:flex-row sm:justify-start sm:items-end border-stone"
      backgroundImage={backgroundImage ? backgroundImage.url : null}
    >
      <div className="pb-12 text-left">
        <Animated>
          <h1 className="max-w-3xl pt-16 text-3xl leading-tight font-playfair md:text-4xl" dangerouslySetInnerHTML={{__html: subtitle}} />
          <div className="max-w-3xl mt-1 mb-4 text-3xl leading-tight font-playfair md:text-4xl">{headline}</div>
        </Animated>
        <Grow className="w-0 h-6" style={{borderTop: '6px solid #46ff46'}} />
        <div className="mt-6">
          {button1Label &&
            <Button label={button1Label} link={button1Link ? button1Link : '#'} />
          }
          {button1Label &&
            <Button label={button2Label} link={button2Link ? button2Link : '#'} />
          }
        </div>
      </div>
    </HeroContainer>
  );
};
